import React from "react";
import { useOctopusTheme } from "~/components/Theme/index";
export const GreenTickIcon = (): JSX.Element => {
    const theme = useOctopusTheme();
    return <em className={"fa-solid fa-circle-check"} style={{ color: theme.success, marginTop: "10px" }} aria-hidden="true"/>;
};
